/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";
import * as React from "react";
import axios from "axios";
import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import Card from "@mui/material/Card";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// NewUser page components
import FormField from "layouts/pages/users/new-user/components/FormField";
import { Field, ErrorMessage } from "formik";

// Import variabel API
import { API_HOHOLOK } from "utils";

function InfoUser({ formData }) {
  const { formField, values, errors, touched, setValues } = formData;
  const {
    nama,
    instansi,
    perusahaan,

    status,
    nama_user,
  } = formField;
  const {
    nama: namaV,
    instansi: instansiV,
    perusahaan: perusahaanV,

    uid_RSS: uid_RSSV,

    status: statusV,
    nama_user: nama_userV,
  } = values;

  const [loadingStruktur, setLoadingStruktur] = React.useState(true);
  const [listPerusahaan, setListPerusahaan] = React.useState([]);
  const [perusahaanOptions, setPerusahaanOptions] = React.useState([]);

  React.useEffect(() => {
    // Ambil user dari localStorage dan set instansi jika ada

    const fetchPerusahaan = async () => {
      setLoadingStruktur(true);
      try {
        const res = await axios.get(`${API_HOHOLOK}perusahaan`);
        setListPerusahaan(res.data && res.data[0] ? res.data[0] : null);
        const perusahaanOptions = res.data;

        setPerusahaanOptions([
          { value: "", label: "Pilih Perusahaan" },
          ...perusahaanOptions.map((j) => ({
            value: j.id_perusahaan,
            label: j.nama_perusahaan,
          })),
        ]);
      } catch (err) {
        setListPerusahaan(null);
      }
      setLoadingStruktur(false);
    };
    fetchPerusahaan();
  }, []);

  React.useEffect(() => {
    setValues({
      ...values,

      uid_RSS: uid_RSSV,

      dinas_id: 7,
    });
  }, []);

  // Tambahkan useEffect untuk set perusahaan ke 2 jika statusV === 'admin'
  React.useEffect(() => {
    if (statusV === "admin" && values.perusahaan !== 2) {
      setValues({
        ...values,
        perusahaan: 2,
      });
    }
    // eslint-disable-next-line
  }, [statusV]);

  // Ambil opsi jabatan dari dinasStruktur jika ada

  return (
    <MDBox>
      <MDTypography variant="h5" fontWeight="bold">
        Informasi User
      </MDTypography>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              type={nama.type}
              label={nama.label}
              name={nama.name}
              value={namaV}
              placeholder={nama.placeholder}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={status.type}
              label={status.label}
              name={status.name}
              value={statusV}
              options={[
                { value: "", label: "Pilih Status" },
                { value: "user", label: "User" },
                { value: "admin", label: "Admin" },
              ]}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} mt={2}>
          {statusV === "admin" ? (
            <Grid item xs={12} sm={6}>
              <MDBox mt={-1.625}>
                <FormField
                  type={instansi.type}
                  label={instansi.label}
                  name={instansi.name}
                  value={instansiV}
                  placeholder={instansi.placeholder}
                />
              </MDBox>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6}>
              <FormField
                type="select"
                label={perusahaan.label}
                name={perusahaan.name}
                value={perusahaanV}
                options={perusahaanOptions || []}
                onChange={(e) => {
                  const selectedPerusahaan = e.target.value;
                  setValues({
                    ...values,
                    perusahaan: selectedPerusahaan,
                  });
                }}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <FormField
              type="text"
              label={nama_user.label}
              name={nama_user.name}
              value={nama_userV}
              placeholder={nama_user.placeholder}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

// typechecking props for Address
InfoUser.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default InfoUser;
